export const classFormation = (classes) => classes.join(" ");
